import type { VehicleFuelEconomy } from '@makemydeal/dr-activities-fuel-saving';

type FuelEconomyVehicleTab = {
    id?: string;
    combinedFuelEconomy?: number;
};

export type FuelEconomyFetchPlan = {
    sellingVehiclesWithData: VehicleFuelEconomy[];
    sellingVinsForApi: string[];
    tradeInVinsForApi: string[];
    canUseExistingData: boolean;
};

/**
 * Builds a normalized plan for using init fuel-economy data and deciding
 * which VINs still require the fuel-economy API call.
 */
export const buildFuelEconomyFetchPlan = (
    vehicleTabs: FuelEconomyVehicleTab[],
    tradeinVehiclesVin: string[],
    tradeInFuelEconomyFromInit: VehicleFuelEconomy[]
): FuelEconomyFetchPlan => {
    const tabsWithFuelEconomy = vehicleTabs.filter((tab) => tab.combinedFuelEconomy != null);
    const tabsWithoutFuelEconomy = vehicleTabs.filter((tab) => tab.combinedFuelEconomy == null);

    const sellingVehiclesWithData: VehicleFuelEconomy[] = tabsWithFuelEconomy
        .filter((tab): tab is Required<Pick<FuelEconomyVehicleTab, 'id'>> & FuelEconomyVehicleTab => Boolean(tab.id))
        .map((tab) => ({
            vin: tab.id,
            ok: true,
            fuelEconomy: {
                combined: tab.combinedFuelEconomy
            }
        }));

    const sellingVinsForApi = tabsWithoutFuelEconomy.map((tab) => tab.id).filter((vin): vin is string => Boolean(vin));
    const tradeInVinsWithInit = new Set(tradeInFuelEconomyFromInit.map((tradeIn) => tradeIn.vin));
    const tradeInVinsForApi = tradeinVehiclesVin.filter((vin) => !tradeInVinsWithInit.has(vin));
    const allTradeInsHaveInitData = tradeinVehiclesVin.length === tradeInFuelEconomyFromInit.length;
    const canUseExistingData = sellingVinsForApi.length === 0 && allTradeInsHaveInitData;

    return {
        sellingVehiclesWithData,
        sellingVinsForApi,
        tradeInVinsForApi,
        canUseExistingData
    };
};
